
import LogoHeart from './LogoHeart.vue'

export default {
  name: 'fitnhealthy-logo',
  components: {
    LogoHeart
  }
}
